import i18n from "i18next";
import { initReactI18next } from "react-i18next";

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    // the translations
    // (tip move them in a JSON file and import them,
    // or even better, manage them via a UI: https://react.i18next.com/guides/multiple-translation-files#manage-your-translations-with-a-management-gui)
    resources: {
      en: {
        translation: {
          "Dossier clients": "Client records",
          "Dossier clients >": "Client records >",
          "Missions": "Assignments",
          "Missions >": "Assignments >",
          "Documents": "Documents",
          "Documents >": "Documents >",
          "Dossier clients social": "Social client records",
          "Dossier clients social >": "Social client records >",
          "Salariés": "Employees",
          "Salariés >": "Employees >",
          "Eléments": "Elements",
          "Eléments >": "Elements >",
          "Bulletins": "Payslips",
          "Bulletins >": "Payslips >",
          "Validation saisie": "Entry validation",
          "Ajouter un salarié +": "Add an employee +",
          "Télécharger tous": "Download all",
          "Télécharger tous les documents": "Download all documents",
          "Import Salariés": "Import employees",
          "Export Sage": "Export Sage",
          "Recap salariés": "Employee recap",
          "Annuler la validation": "Cancel validation",
          "Nom": "Last name",
          "Mois": "Month",
          "Fin de saisie": "End of entry",
          "Validation": "Validation",
          "Statut": "Status",
          "Matricule": "Employee ID",
          "Prénom": "First name",
          "Actions": "Actions",
          "Validé": "Validated",
          "En cours": "In progress",
          "Aucune donnée disponible": "No data available",
          "Les données apparaîtront ici une fois ajoutées": "Data will appear here once added",
          "Simulateur de paie": "Payroll simulator",
          "Assigner": "Assign",
          "Supprimer": "Delete",
          "flèche": "arrow",
          "Guide": "Guide",
          "Une erreur est survenue": "An error occurred",
          "Aucun document trouvé": "No document found",
          "Importation effectuée": "Import completed",
          "Une erreur est survenue lors du téléchargement": "An error occurred during download",
          "Annulation de la validation effectuée": "Validation cancellation completed",
          "Bienvenue sur votre espace client": "Welcome to your customer area",
          "Accédez à vos services et informations en toute simplicité.": "Access your services and information with ease.",
          "Employé validé avec succès": "Employee validated successfully",
          "Employé dévalidé avec succès": "Employee unvalidated successfully",
          "Gestion des absences": "Absence management",
          "Gestion des valeurs": "Values management",
          "Annuler la fin de saisie": "Cancel end of entry",
          "Ajouter": "Add",
          "une absence": "an absence",
          "une valeur": "a value",
          "Type": "Type",
          "Début": "Start",
          "Fin": "End",
          "Matin": "Morning",
          "Après midi": "Afternoon",
          "Après-midi": "Afternoon",
          "Prolongation": "Extension",
          "Commentaire": "Comment",
          "Valeur": "Value",
          "Salarié modifié avec succès": "Employee updated successfully",
          "Commentaire modifié avec succès": "Comment updated successfully",
          "Commentaire ajouté avec succès": "Comment added successfully",
          "Commentaire supprimé avec succès": "Comment deleted successfully",
          "Période en cours": "Current period",
          "Chargement...": "Loading...",
          "Informations": "Information",
          "Informations générales": "General information",
          "Entreprise": "Company",
          "Entreprise:": "Company:",
          "Informations du salarié": "Employee information",
          "Modifier": "Edit",
          "Matricule :": "Employee ID:",
          "Fin de saisie effectuée": "End of entry completed",
          "Commentaire:": "Comment:",
          "Documents du salarié": "Employee documents",
          "Valeur créée avec succès": "Value created successfully",
          "Erreur lors de la création de la valeur": "Error while creating value",
          "Absence créée avec succès": "Absence created successfully",
          "Erreur lors de la création de l'absence": "Error while creating absence",
          "Absence modifiée avec succès": "Absence updated successfully",
          "Erreur lors de la modifications de l'absence": "Error while updating absence",
          "Valeur modifiée avec succès": "Value updated successfully",
          "Erreur lors de la modification de la valeur": "Error while updating value",
          "ATTENTION": "WARNING",
          "Il y a un chevauchement de date, êtes vous sur de vouloir continuer ?": "There is a date overlap, are you sure you want to continue?",
          "Valider": "Confirm",
          "Les bulletins ont déjà été validés.": "Payslips have already been validated.",
          "Créer": "Create",
          "Ajoutez un nouvel élément": "Add a new item",
          "Modifiez les informations": "Edit the information",
          "Informations principales": "Main information",
          "Type d'élément": "Item type",
          "Date de début": "Start date",
          "Date de fin": "End date",
          "Prolongations": "Extensions",
          "Date d'arret initial": "Initial stop date",
          "Oui": "Yes",
          "Non": "No",
          "Ajoutez des éléments pour les voir apparaître ici": "Add items to make them appear here",
          "Absences": "Absences",
          "Valeurs": "Values",
          "Bulletins de paie": "Payslips",
          "Mois non défini": "Month not defined",
          "Valider le mois": "Validate month",
          "Refuser": "Reject",
          "Valider les bulletins": "Validate payslips",
          "Suivi": "Tracking",
          "Bulletins validés par": "Payslips validated by",
          "Bulletins refusés par": "Payslips rejected by",
          "Aucun suivi enregistré": "No tracking recorded",
          "Veuillez sélectionner un seul fichier à la fois": "Please select only one file at a time",
          "Bulletin envoyé avec succès": "Payslip uploaded successfully",
          "Une erreur est survenue lors de l'envoi du document": "An error occurred while sending the document",
          "Une erreur est survenue lors de la récupération des bulletins": "An error occurred while retrieving payslips",
          "Nombre de bulletins modifié avec succès": "Number of payslips updated successfully",
          "Une erreur est survenue lors de la modification du nombre de bulletins": "An error occurred while updating the number of payslips",
          "Nombre de bulletins": "Number of payslips",
          "Aucun bulletin déposé": "No payslip uploaded",
          "Les bulletins apparaîtront ici une fois déposés": "Payslips will appear here once uploaded",
          "Bulletins de": "Payslips for",
          "Dernier dépôt :": "Last upload:",
          "Télécharger les bulletins": "Download payslips",
          "Déposez le fichier ici": "Drop the file here",
          "Glissez-déposez votre fichier": "Drag and drop your file",
          "ou cliquez pour sélectionner": "or click to select",
          "Les bulletins ont été refusés avec succès": "Payslips were rejected successfully",
          "Erreur lors de la validation des bulletins": "Error while validating payslips",
          "Refuser les bulletins": "Reject payslips",
          "Etes vous sur de bien vouloir refuser les bulletins séléctionnés ?": "Are you sure you want to reject the selected payslips?",
          "Cette action est irréversible.": "This action is irreversible.",
          "Messagerie": "Messaging",
          "Aucun message": "No message",
          "Commencez la conversation": "Start the conversation",
          "Écrivez votre message...": "Write your message...",
          "Envoyer": "Send",
          "Erreur lors du téléchargement du fichier": "Error while downloading file",
          "Document": "Document",
          "Télécharger": "Download",
          "Aucun document": "No document",
          "Déposez vos premiers documents": "Upload your first documents",
          "Le document a été supprimé avec succès": "Document deleted successfully",
          "Erreur lors de la suppression du document": "Error while deleting document",
          "Suppression": "Deletion",
          "Souhaitez vous vraiment supprimer le document ?": "Do you really want to delete this document?",
          "Les bulletins sont déja validés pour ce mois": "Payslips are already validated for this month",
          "Veuillez déposer vos documents ici": "Please drop your documents here",
          "Votre espace de facturation": "Your billing area",
          "Factures": "Invoices",
          "Notes de crédit": "Credit notes",
          "Aucune facture trouvée": "No invoice found",
          "Vos documents de facturation apparaîtront ici": "Your billing documents will appear here",
          "Visualiser": "View",
          "Aucun document disponible": "No document available",
          "Voir plus": "See more",
          "Information client": "Customer information",
          "Information direction": "Management information",
          "Aucune information de direction disponible pour le moment...": "No management information available at the moment...",
          "Création d'un salarié": "Create an employee",
          "Retour": "Back",
          "Guides": "Guides",
        }
      },
      fr: {
        translation: {
          "Dossier clients": "Dossier clients",
          "Dossier clients >": "Dossier clients >",
          "Missions": "Missions",
          "Missions >": "Missions >",
          "Documents": "Documents",
          "Documents >": "Documents >",
          "Dossier clients social": "Dossier clients social",
          "Dossier clients social >": "Dossier clients social >",
          "Salariés": "Salariés",
          "Salariés >": "Salariés >",
          "Eléments": "Eléments",
          "Eléments >": "Eléments >",
          "Bulletins": "Bulletins",
          "Bulletins >": "Bulletins >",
          "Validation saisie": "Validation saisie",
          "Ajouter un salarié +": "Ajouter un salarié +",
          "Télécharger tous": "Télécharger tous",
          "Télécharger tous les documents": "Télécharger tous les documents",
          "Import Salariés": "Import Salariés",
          "Export Sage": "Export Sage",
          "Recap salariés": "Recap salariés",
          "Annuler la validation": "Annuler la validation",
          "Nom": "Nom",
          "Mois": "Mois",
          "Fin de saisie": "Fin de saisie",
          "Validation": "Validation",
          "Statut": "Statut",
          "Matricule": "Matricule",
          "Prénom": "Prénom",
          "Actions": "Actions",
          "Validé": "Validé",
          "En cours": "En cours",
          "Aucune donnée disponible": "Aucune donnée disponible",
          "Les données apparaîtront ici une fois ajoutées": "Les données apparaîtront ici une fois ajoutées",
          "Simulateur de paie": "Simulateur de paie",
          "Assigner": "Assigner",
          "Supprimer": "Supprimer",
          "flèche": "flèche",
          "Guide": "Guide",
          "Une erreur est survenue": "Une erreur est survenue",
          "Aucun document trouvé": "Aucun document trouvé",
          "Importation effectuée": "Importation effectuée",
          "Une erreur est survenue lors du téléchargement": "Une erreur est survenue lors du téléchargement",
          "Annulation de la validation effectuée": "Annulation de la validation effectuée",
          "Bienvenue sur votre espace client": "Bienvenue sur votre espace client",
          "Accédez à vos services et informations en toute simplicité.": "Accédez à vos services et informations en toute simplicité.",
          "Employé validé avec succès": "Employé validé avec succès",
          "Employé dévalidé avec succès": "Employé dévalidé avec succès",
          "Gestion des absences": "Gestion des absences",
          "Gestion des valeurs": "Gestion des valeurs",
          "Annuler la fin de saisie": "Annuler la fin de saisie",
          "Ajouter": "Ajouter",
          "une absence": "une absence",
          "une valeur": "une valeur",
          "Type": "Type",
          "Début": "Début",
          "Fin": "Fin",
          "Matin": "Matin",
          "Après midi": "Après midi",
          "Après-midi": "Après-midi",
          "Prolongation": "Prolongation",
          "Commentaire": "Commentaire",
          "Valeur": "Valeur",
          "Salarié modifié avec succès": "Salarié modifié avec succès",
          "Commentaire modifié avec succès": "Commentaire modifié avec succès",
          "Commentaire ajouté avec succès": "Commentaire ajouté avec succès",
          "Commentaire supprimé avec succès": "Commentaire supprimé avec succès",
          "Période en cours": "Période en cours",
          "Chargement...": "Chargement...",
          "Informations": "Informations",
          "Informations générales": "Informations générales",
          "Entreprise": "Entreprise",
          "Entreprise:": "Entreprise:",
          "Informations du salarié": "Informations du salarié",
          "Modifier": "Modifier",
          "Matricule :": "Matricule :",
          "Fin de saisie effectuée": "Fin de saisie effectuée",
          "Commentaire:": "Commentaire:",
          "Documents du salarié": "Documents du salarié",
          "Valeur créée avec succès": "Valeur créée avec succès",
          "Erreur lors de la création de la valeur": "Erreur lors de la création de la valeur",
          "Absence créée avec succès": "Absence créée avec succès",
          "Erreur lors de la création de l'absence": "Erreur lors de la création de l'absence",
          "Absence modifiée avec succès": "Absence modifiée avec succès",
          "Erreur lors de la modifications de l'absence": "Erreur lors de la modifications de l'absence",
          "Valeur modifiée avec succès": "Valeur modifiée avec succès",
          "Erreur lors de la modification de la valeur": "Erreur lors de la modification de la valeur",
          "ATTENTION": "ATTENTION",
          "Il y a un chevauchement de date, êtes vous sur de vouloir continuer ?": "Il y a un chevauchement de date, êtes vous sur de vouloir continuer ?",
          "Valider": "Valider",
          "Les bulletins ont déjà été validés.": "Les bulletins ont déjà été validés.",
          "Créer": "Créer",
          "Ajoutez un nouvel élément": "Ajoutez un nouvel élément",
          "Modifiez les informations": "Modifiez les informations",
          "Informations principales": "Informations principales",
          "Type d'élément": "Type d'élément",
          "Date de début": "Date de début",
          "Date de fin": "Date de fin",
          "Prolongations": "Prolongations",
          "Date d'arret initial": "Date d'arret initial",
          "Oui": "Oui",
          "Non": "Non",
          "Ajoutez des éléments pour les voir apparaître ici": "Ajoutez des éléments pour les voir apparaître ici",
          "Absences": "Absences",
          "Valeurs": "Valeurs",
          "Bulletins de paie": "Bulletins de paie",
          "Mois non défini": "Mois non défini",
          "Valider le mois": "Valider le mois",
          "Refuser": "Refuser",
          "Valider les bulletins": "Valider les bulletins",
          "Suivi": "Suivi",
          "Bulletins validés par": "Bulletins validés par",
          "Bulletins refusés par": "Bulletins refusés par",
          "Aucun suivi enregistré": "Aucun suivi enregistré",
          "Veuillez sélectionner un seul fichier à la fois": "Veuillez sélectionner un seul fichier à la fois",
          "Bulletin envoyé avec succès": "Bulletin envoyé avec succès",
          "Une erreur est survenue lors de l'envoi du document": "Une erreur est survenue lors de l'envoi du document",
          "Une erreur est survenue lors de la récupération des bulletins": "Une erreur est survenue lors de la récupération des bulletins",
          "Nombre de bulletins modifié avec succès": "Nombre de bulletins modifié avec succès",
          "Une erreur est survenue lors de la modification du nombre de bulletins": "Une erreur est survenue lors de la modification du nombre de bulletins",
          "Nombre de bulletins": "Nombre de bulletins",
          "Aucun bulletin déposé": "Aucun bulletin déposé",
          "Les bulletins apparaîtront ici une fois déposés": "Les bulletins apparaîtront ici une fois déposés",
          "Bulletins de": "Bulletins de",
          "Dernier dépôt :": "Dernier dépôt :",
          "Télécharger les bulletins": "Télécharger les bulletins",
          "Déposez le fichier ici": "Déposez le fichier ici",
          "Glissez-déposez votre fichier": "Glissez-déposez votre fichier",
          "ou cliquez pour sélectionner": "ou cliquez pour sélectionner",
          "Les bulletins ont été refusés avec succès": "Les bulletins ont été refusés avec succès",
          "Erreur lors de la validation des bulletins": "Erreur lors de la validation des bulletins",
          "Refuser les bulletins": "Refuser les bulletins",
          "Etes vous sur de bien vouloir refuser les bulletins séléctionnés ?": "Etes vous sur de bien vouloir refuser les bulletins séléctionnés ?",
          "Cette action est irréversible.": "Cette action est irréversible.",
          "Messagerie": "Messagerie",
          "Aucun message": "Aucun message",
          "Commencez la conversation": "Commencez la conversation",
          "Écrivez votre message...": "Écrivez votre message...",
          "Envoyer": "Envoyer",
          "Erreur lors du téléchargement du fichier": "Erreur lors du téléchargement du fichier",
          "Document": "Document",
          "Télécharger": "Télécharger",
          "Aucun document": "Aucun document",
          "Déposez vos premiers documents": "Déposez vos premiers documents",
          "Le document a été supprimé avec succès": "Le document a été supprimé avec succès",
          "Erreur lors de la suppression du document": "Erreur lors de la suppression du document",
          "Suppression": "Suppression",
          "Souhaitez vous vraiment supprimer le document ?": "Souhaitez vous vraiment supprimer le document ?",
          "Les bulletins sont déja validés pour ce mois": "Les bulletins sont déja validés pour ce mois",
          "Veuillez déposer vos documents ici": "Veuillez déposer vos documents ici",
          "Votre espace de facturation": "Votre espace de facturation",
          "Factures": "Factures",
          "Notes de crédit": "Notes de crédit",
          "Aucune facture trouvée": "Aucune facture trouvée",
          "Vos documents de facturation apparaîtront ici": "Vos documents de facturation apparaîtront ici",
          "Visualiser": "Visualiser",
          "Aucun document disponible": "Aucun document disponible",
          "Voir plus": "Voir plus",
          "Information client": "Information client",
          "Information direction": "Information direction",
          "Aucune information de direction disponible pour le moment...": "Aucune information de direction disponible pour le moment...",
          "Création d'un salarié": "Création d'un salarié",
          "Retour": "Retour",
          "Guides": "Guides",
        }
      }
    },
    lng: "fr", // if you're using a language detector, do not define the lng option
    fallbackLng: "fr",

    react: {
      useSuspense: false,
    },

    interpolation: {
      escapeValue: false // react already safes from xss => https://www.i18next.com/translation-function/interpolation#unescape
    }
  });

i18n.on("languageChanged", (lng) => {
  document.documentElement.lang = lng;
});